<div class="container-fluid" *transloco="let t">
  <div class="container">
    @let item = newsItem();
    <div class="row">
      <div class="col-lg-8">

        @if (item) {
          <div class="row mt-3">
            <div class="col">
              <h1 class="font-weight-bold mt-3 text-break">{{ item.title }}</h1>
              <p class="text-muted mb-2">
                @if (item.byline) {
                  <span>{{ item.byline }}</span>
                  <span class="mx-1">·</span>
                }
                <span>{{ item.publishedAt | date: 'longDate' }}</span>
                @if (item.publicUpdatedAt) {
                  <span class="mx-1">·</span>
                  <span>{{ t('common.updated') }} {{ item.publicUpdatedAt | date: 'longDate' }}</span>
                }
              </p>
              @if (item.platformWide || item.topics.length || item.cultures.length || item.tags.length) {
                <div class="d-flex flex-wrap gap-1 mb-3">
                  @if (item.platformWide) {
                    <span class="badge badge-pill badge-info">{{ t('common.platform_wide') }}</span>
                  }
                  @for (topic of item.topics; track topic.id) {
                    <span class="badge badge-pill badge-info">{{ topic.name }}</span>
                  }
                  @for (culture of item.cultures; track culture.id) {
                    <span class="badge badge-pill badge-info">{{ culture.name }}</span>
                  }
                  @for (tag of item.tags; track tag.id) {
                    <span class="badge badge-pill badge-primary">{{ tag.name }}</span>
                  }
                </div>
              }
              @if (translating()) {
                <div class="d-flex align-items-center gap-2 my-2" role="status">
                  <multisite-loader-globe-animation-detail [width]="40" [height]="40"></multisite-loader-globe-animation-detail>
                  <span>{{ t('news.translating') }}</span>
                </div>
              }
              @if (item.headline) {
                <p class="lead">{{ item.headline }}</p>
              }
            </div>
          </div>

          @if (item.videos.length) {
            <div class="mt-3">
              @for (video of item.videos; track video.id) {
                <frontend-video-player-type-two [video]="video" [classes]="'mb-3'"></frontend-video-player-type-two>
              }
            </div>
          } @else if (image(); as cover) {
            <img class="w-100 mt-3" [src]="cover | imageUrl: 'w_700,c_fill,ar_16:9'" [alt]="cover.alt_text ?? ''" />
          }

          <div class="my-4 text-break" [innerHTML]="item.body | insightMarkdown"></div>
        }

        @if (!item && isAnythingLoading()) {
          <div class="row mt-3">
            <div class="col">
              <h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5>
              <p class="card-text placeholder-glow">
                <span class="placeholder col-7"></span>
                <span class="placeholder col-4"></span>
                <span class="placeholder col-4"></span>
                <span class="placeholder col-6"></span>
                <span class="placeholder col-8"></span>
              </p>
              <multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail>
            </div>
          </div>
        }

        @if (notFound()) {
          <alert [type]="'warning'" class="d-block mt-4">
            <div class="text-center my-4">
              <p>{{ t('news.not_found') }}</p>
              <a [routerLink]="['..']">{{ t('news.all_news') }}</a>
            </div>
          </alert>
        }

        @if (failed()) {
          <alert [type]="'danger'" class="d-block mt-4">
            <div class="text-center my-4">{{ t('error.something_went_wrong') }}</div>
          </alert>
        }
      </div>

      <div class="col-lg-4">
        <div class="mt-5 sticky-top">
          <div class="container-card-wrap">
            <div class="wrap-body">
              <div class="card-optional-content">
                <p class="h5">{{ t('news.more_news') }}</p>
                <div class="list-group list-group-flush">
                  @for (other of moreNews(); track other.id) {
                    <a class="list-group-item list-group-item-action px-0" [routerLink]="['..', other.slug]">
                      <span class="d-block">{{ other.shortTitle || other.title }}</span>
                      <small class="text-muted">{{ other.publishedAt | date: 'mediumDate' }}</small>
                    </a>
                  }
                </div>
                <a class="btn btn-link px-0 mt-2" [routerLink]="['..']">
                  {{ t('news.all_news') }} <i class="fa-solid fa-angle-right ml-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
